"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLang = void 0;
var react_1 = require("react");
var lodash_1 = require("lodash");
var use_entities_1 = require("./use-entities");
var pluralize_1 = __importDefault(require("pluralize"));
var BASE_LANG = process.env.BASE_LANG || 'en';
var langDict = {};
var useLang = function () {
  var entities = (0, use_entities_1.useEntities)();
  // todo add cleaner support for lang like in @shapeable/web 
  // generate a temmplate data dictionary to allow entity labels to be used
  var templateData = (0, react_1.useMemo)(function () {
    var ret = (0, lodash_1.mapValues)(entities, function (definition) {
      return __assign(__assign({}, (0, lodash_1.pick)(definition, ['label', 'pluralLabel', 'aLabel', 'slug', 'pluralSlug'])), {
        plural: definition.pluralLabel,
        single: definition.label,
        a: definition.aLabel
      });
    });
    return __assign(__assign({}, ret), (0, lodash_1.reduce)(entities, function (acc, definition, entityTypeName) {
      acc[(0, lodash_1.snakeCase)(entityTypeName).toUpperCase()] = definition.label;
      acc[(0, lodash_1.snakeCase)(pluralize_1.default.plural(entityTypeName)).toUpperCase()] = definition.pluralLabel;
      acc["A_".concat((0, lodash_1.snakeCase)(entityTypeName).toUpperCase())] = definition.aLabel;
      return acc;
    }, {}));
  }, [entities]);
  var t = function (name) {
    if (!name) {
      return '';
    }
    if (langDict[name]) {
      return langDict[name];
    }
    try {
      var result = (0, lodash_1.template)(name, {
        interpolate: /{{([\s\S]+?)}}/g
      })(templateData);
      langDict[name] = result;
      return result;
    } catch (e) {
      // console.warn(e);
      return '';
    }
  };
  return t;
};
exports.useLang = useLang;